import React, { Component } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import { connect } from "react-redux";
import CheckBoxIcon from "@material-ui/icons/CheckBoxOutlined";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Lightbox } from "react-modal-image";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
class ProductCheckBoxField extends Component {
  state = {
    openExampleImage: false,
    checked: false,
  };
  toggle = () => {
    const newChecked = !this.state.checked;
    this.setState({ checked: newChecked });
    this.props.setExtrafield(
      this.props.extraField,
      newChecked,
      this.props.groupID
    );
  };
  render() {
    const { extraField, language, settings, selectedExtraField, extraID } =
      this.props;
    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <div
        className="border mt-4 px-3 py-2"
        style={{
          backgroundColor: "white",
          flex: 1,
          justifyContent: "space-between",
          display: "flex",
          alignItems: "center",
          right: language === "arabic" && 0,
          flexDirection: language === "arabic" && "row-reverse",
        }}
        onClick={this.toggle}
      >
        <div
          style={{
            display: "flex",
            flexDirection: language === "arabic" && "row-reverse",
            alignItems: "center",
          }}
        >
          {extraField.image && this.state.openExampleImage && (
            <div>
              <Lightbox
                hideDownload
                medium={extraField.image}
                large={extraField.image}
                alt={
                  language === "arabic" ? extraField.ar_name : extraField.name
                }
                onClose={() => this.setState({ openExampleImage: false })}
              />
            </div>
          )}
          <Checkbox
            checked={this.state.checked}
            onChange={this.toggle}
            style={{
              padding: 6,
              paddingLeft: language == "english" && 0,
              paddingRight: language == "arabic" && 0,
            }}
            checkedIcon={<CheckBoxIcon style={{ color: themeColor }} />}
          />
          {extraField.image && extraField.image_style == "avatar" && (
            <div style={{ position: "relative" }}>
              <ZoomInIcon
                onClick={() => this.setState({ openExampleImage: true })}
                style={{
                  position: "absolute",

                  color: themeColor,
                  fontSize: 25,
                  padding: 2,
                  backgroundColor: "hsla(0,0%,100%,.8)",

                  borderRadius: 5,
                }}
              />
              <img
                onClick={() => this.setState({ openExampleImage: true })}
                style={{
                  objectFit: "contain",
                  padding: 5,
                  width: 60,
                  height: 60,
                  borderRadius: 10,
                }}
                src={extraField.image}
              />
            </div>
          )}
          <span style={{ textAlign: language === "arabic" ? "right" : "left" }}>
            {(language === "arabic" && extraField.ar_name) || extraField.name}
          </span>
          {extraField.image && extraField.image_style == "icon" && (
            <>
              <InfoOutlinedIcon
                style={{ color: themeColor, cursor: "pointer", width: 18 }}
                onClick={() => this.setState({ openExampleImage: true })}
              />
            </>
          )}
        </div>
        {extraField.price > 0 && (
          <div
            style={{
              color: themeColor,
              fontWeight: "bold",
              whiteSpace: "nowrap",
            }}
          >
            {extraField.price && " + "}
            <span
              className={currencyIcon}
            >
              {extraField.price
                ? `${
                    language === "arabic"
                      ? settings.currency_local
                      : settings.currency_english
                  } ${extraField.price?.toFixed(settings.currency_decimals)}`
                : "0.000"}
            </span>
          </div>
        )}
      </div>
    );
    return (
      <div
        className="border mt-4"
        style={{
          backgroundColor: "white",
          height: "108px",
          position: "relative",
        }}
      >
        <div
          className="mx-3"
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: language === "arabic" && "row-reverse",
            position: "absolute",
            top: "50%",
            msTransform: "translateY(-50%)",
            transform: "translateY(-50%)",
            right: language === "arabic" && 0,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: language === "arabic" && "row-reverse",
            }}
          >
            <div>
              <Checkbox
                onChange={(e) =>
                  this.props.setExtrafield(
                    extraField,
                    e.target.checked,
                    this.props.groupID
                  )
                }
                checkedIcon={<CheckBoxIcon style={{ color: themeColor }} />}
              />
              <span>
                {(language === "arabic" && extraField.ar_name) ||
                  extraField.name}
              </span>
            </div>
            {extraField.price > 0 && (
              <div
                style={{
                  color: themeColor,
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                {extraField.price && " + "}
                <span
                  className={
                    currencyIcon
                  }
                >
                  {extraField.price
                    ? `${
                        language === "arabic"
                          ? settings.currency_local
                          : settings.currency_english
                      } ${extraField.price?.toFixed(
                        settings.currency_decimals
                      )}`
                    : "0.000"}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    settings: state.store.store.settings,
    language: state.store.language,
    themeColor: state.store.store.settings.dark || "#0099cc",
  };
};

export default connect(mapStateToProps)(ProductCheckBoxField);
